import React, { FC, useState } from 'react';
import {
  Container,
  BigInfo,
  Body,
  ItemsWrapper,
  Item,
  ImgBig,
  ItemTitle,
  LinkContainer,
  RuleItem,
  FoundedBlock,
  YoursBlock,
} from './styles'
import { Button, Typography } from '../../../../components';
import { useTranslation } from 'react-i18next';
import { affiliateService } from '../../../../api';
import { useUi } from '../../../../context/ui.context';
import { useTheme } from 'styled-components';
import BigImg from './big-default.svg'
import BigImgDark from './big-dark.svg'
import { ArrowRight, MoneyIc, MoneyWithdrawIc, ShareIcon } from '../../../../icons-components/affiliate';


const formatNumericValue = (value: any): string | null => {
  if (value === null || value === undefined) return null;
  const numeric = Number(value);
  if (!Number.isFinite(numeric)) return null;
  const formatted = numeric % 1 === 0 ? numeric.toString() : numeric.toFixed(2);
  if (!formatted.includes('.')) return formatted;
  return formatted.replace(/\.?0+$/, '');
};

const NoAffiliate:FC<any> = ({getRefData, setPageLoading, defaultConfig}) => {
  const {viewAlert} = useUi()
  const theme:any = useTheme()
  const [loading, setLoading] = useState<boolean>(false)
  const [loadingComplete, setLoadingComplete] = useState<boolean>(false)
  const [t] = useTranslation()
  const formattedPercent = formatNumericValue(defaultConfig?.percent_payment) ?? '0';
  const percentDisplay = `${formattedPercent}%`;
  const signupBonusAmount = formatNumericValue(defaultConfig?.signup_bonus_value);
  const hasSignupBonus = Boolean(defaultConfig?.signup_bonus && signupBonusAmount);
  const createAffiliate = () => {
    setLoading(true)
    affiliateService.createRef()
    .then((res) => {
      setLoadingComplete(true)
      setTimeout(() => {
        getRefData()
        setLoadingComplete(false)
        setLoading(false)
        setPageLoading(true)
      },1000)
    })
    .catch((err) => {
      viewAlert({
        severity: 'error',
        message: err?.response?.data?.detail || t("ERROR_OCCURRED")
      })
    })
  }
  return (
    <Container>
      <Typography variant='h1'>
        {t("AFFILIATE")}
      </Typography>
      <Body>
        <BigInfo>
          <div style={{display:'flex', flexDirection:'column', gap:'6px'}}>
            <Typography  variant='h2'>
              <span>{t("GET")}</span>
              <span style={{margin:'0px',color:theme.primary[600]}}> {percentDisplay} </span>
              <span>{t("FROM_EVERY_DEPOSIT")}</span>
            </Typography>
            <Typography variant='body'>
              {t("DEPOSIT_PERCENT_DESCRIPTION", { percent: formattedPercent })}
            </Typography>
            {hasSignupBonus && (
              <Typography variant='body'>
                {t("SIGNUP_BONUS_DESCRIPTION", { amount: signupBonusAmount })}
              </Typography>
            )}
          </div>
          <Button
            title={t("GENERATE_LINK")}
            variant='primary'
            size='display'
            onClick={createAffiliate}
            loading={loading}
            loadingComplete={loadingComplete}
            
          />
          <ImgBig src={theme.isDark ? BigImgDark : BigImg}/>
        </BigInfo>
        <ItemsWrapper>
          <Typography variant='h2'>
            {t("RULES")}
          </Typography>
          <Item>
            <ShareIcon styles={{minWidth:"32px"}}/>
            <ItemTitle>
              <Typography variant='body'>
                {t("SHARE_LINK_TITLE")}
              </Typography>
              <LinkContainer>
                https://{window.location.hostname}?ref=
                <span style={{filter:'blur(2.2px)'}}>yjysnwm</span>
              </LinkContainer>
            </ItemTitle>
          </Item>
          <Item>
            <MoneyIc styles={{minWidth:"32px"}}/>
            <ItemTitle>
              <Typography variant='body'>
                {t("CONDITION_TITLE")}
              </Typography>
              <RuleItem>
                <FoundedBlock>{t("REFERRAL_FOUNDED")}</FoundedBlock>
                <ArrowRight color={theme.palette[900]}/>
                <YoursBlock>{percentDisplay} {t("IS_YOURS")}</YoursBlock>
              </RuleItem>
              <Typography variant='body'>
                {t("CONDITION2_TITLE", { percent: formattedPercent })}
              </Typography>
            </ItemTitle>
          </Item>
          <Item>
            <MoneyWithdrawIc styles={{minWidth:"32px"}}/>
            <ItemTitle>
              <Typography variant='body'>
                {t("CONTACT_US_TO_WITHDRAW")}
              </Typography>
              <LinkContainer>
                {t("WITHDRAW_AMOUNT_FROM")} 10$
              </LinkContainer>
            </ItemTitle>
          </Item>
        </ItemsWrapper>
      </Body>

      {/*  */}
  </Container>
  )
}

export default NoAffiliate
